module.exports = __webpack_public_path__ + "img/pt21_samurai02_shop.7cc6296c.png";